import _cloneDeep from 'lodash/cloneDeep';

export default class EscalationsController {

    /* @ngInject */
    constructor($scope, DialogService, ToastService, RulesApiService) {
        this.$scope = $scope;
        this.DialogService = DialogService;
        this.ToastService = ToastService;
        this.RulesApiService = RulesApiService;
    }

    $onInit() {
        this.loadingEscalations = false;
        this.selectedEscalation = null;
        this.isNewEscalation = false;
    }

    get escalations() {
        return this.escalationTemplates || [];
    }

    notifyParent() {
        if (this.onEscalationTemplatesChange) {
            this.onEscalationTemplatesChange({ $event: [...this.escalationTemplates] });
        }
    }

    get isDetailView() {
        return this.selectedEscalation !== null;
    }

    isActive(name) {
        return this.selectedEscalation && this.selectedEscalation.name === name;
    }

    createNewEscalation() {
        this.selectedEscalation = {
            displayName: '',
            escalationLevels: [
                {
                    displayName: 'Level 1',
                    actions: [],
                    escalateAfter: '0s',
                }
            ],
            unacknowledgesAfter: '14400s',
        };
        this.isNewEscalation = true;
    }

    editEscalation(escalation) {
        this.selectedEscalation = _cloneDeep(escalation);
        this.isNewEscalation = false;
    }

    closeDetailView() {
        this.selectedEscalation = null;
        this.isNewEscalation = false;
    }

    getTierCount(escalation) {
        if (!escalation.escalationLevels) return 0;
        return escalation.escalationLevels.length;
    }

    getMethodsSummary(escalation) {
        const methods = new Set();
        if (!escalation.escalationLevels) return '';
        escalation.escalationLevels.forEach(level => {
            if (level.actions) {
                level.actions.forEach(action => {
                    if (action.type === 'EMAIL') methods.add('Email');
                    else if (action.type === 'SMS') methods.add('SMS');
                    else if (action.type === 'PHONE_CALL') methods.add('Phone');
                    else if (action.type === 'WEBHOOK') methods.add('Webhook');
                    else if (action.type) methods.add(action.type);
                });
            }
        });
        return Array.from(methods).join(', ') || 'No actions';
    }

    getContactGroupCount(escalation) {
        const groups = new Set();
        if (!escalation.escalationLevels) return 0;
        escalation.escalationLevels.forEach(level => {
            if (!level.actions) return;
            level.actions.forEach(action => {
                const actionObj = action.sms || action.email || action.phoneCall;
                if (actionObj && actionObj.contactGroups) {
                    actionObj.contactGroups.forEach(cg => groups.add(cg));
                }
            });
        });
        return groups.size;
    }

    duplicateEscalation(escalation) {
        const duplicated = _cloneDeep(escalation);
        duplicated.displayName = `${escalation.displayName} Copy`;
        delete duplicated.name;
        this.selectedEscalation = duplicated;
        this.isNewEscalation = true;
    }

    showDeleteConfirmation({ escalation }) {
        this.DialogService.confirm({
            title: `Delete escalation path "${escalation.displayName}"?`,
            textContent: 'This cannot be undone. Existing alert templates that were created from this escalation path will not be affected.',
            ok: 'Delete',
            cancel: 'Cancel',
            maxWidth: '500px',
        }).then(() => {
            this.deleteEscalation(escalation);
        });
    }

    async deleteEscalation(escalation) {
        try {
            await this.RulesApiService.deleteEscalationPath(escalation.name);
            const index = this.escalationTemplates.findIndex(e => e.name === escalation.name);
            if (index !== -1) this.escalationTemplates.splice(index, 1);
            this.notifyParent();
            this.ToastService.showSimpleText('Escalation path deleted');
            this.closeDetailView();
        } catch (error) {
            const errorMessage = error.data?.error || error.message || 'Unknown error';
            this.ToastService.showSimpleText(`Failed to delete escalation path: ${errorMessage}`);
        }
        this.$scope.$applyAsync();
    }

    async onEscalationCreated(escalation) {
        try {
            const response = await this.RulesApiService.createEscalationPath(this.organizationId, escalation);
            this.escalationTemplates.push(response);
            this.notifyParent();
            this.ToastService.showSimpleText('Escalation path created');
            this.closeDetailView();
        } catch (error) {
            const errorMessage = error.data?.error || error.message || 'Unknown error';
            this.ToastService.showSimpleText(`Failed to create escalation path: ${errorMessage}`);
        }
        this.$scope.$applyAsync();
    }

    async onEscalationUpdated(escalation) {
        try {
            const response = await this.RulesApiService.updateEscalationPath(escalation);
            const index = this.escalationTemplates.findIndex(e => e.name === escalation.name);
            if (index !== -1) {
                this.escalationTemplates[index] = response;
            }
            this.notifyParent();
            this.ToastService.showSimpleText('Escalation path updated');
            this.closeDetailView();
        } catch (error) {
            const errorMessage = error.data?.error || error.message || 'Unknown error';
            this.ToastService.showSimpleText(`Failed to update escalation path: ${errorMessage}`);
        }
        this.$scope.$applyAsync();
    }

}
